/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ /**
 * The entry point for the admin side wp-admin resource (config page).
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/lib/antd.scss";
import "./style/admin.scss";
import { RootStore } from "./store";
import { ConfigApp } from "./components/configApp";
import moment from "moment";
import { handleCorruptRestApi } from "@devowl-wp/utils";
import { request, __ } from "./utils";
import { Provider } from "./components";
import { createRoot } from "react-dom/client";
handleCorruptRestApi({
    [RootStore.get.optionStore.restNamespace]: async ()=>{
        await request({
            location: {
                path: "/plugin"
            }
        });
    },
    ["wp/v2"]: async ()=>{
        await request({
            location: {
                path: "/posts",
                namespace: "wp/v2"
            }
        });
    }
});
const node = document.getElementById(`${RootStore.get.optionStore.slug}-component`);
if (node) {
    createRoot(node).render(/*#__PURE__*/ _jsx(Provider, {
        configProvider: {
            locale: {
                locale: moment.locale(),
                Pagination: {
                    items_per_page: __("/ page")
                }
            }
        },
        children: /*#__PURE__*/ _jsx(ConfigApp, {})
    }));
}
// Expose this functionalities to add-ons, but you need to activate the library functionality
// in your webpack configuration, see also https://webpack.js.org/guides/author-libraries/
export * from "@devowl-wp/utils";
export * from "./wp-api";
export * from "./store";
